import { Component, inject } from '@angular/core';
import { IntensityService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  IntensityCreateDto,
  IntensityDto,
  IntensityExcelDownloadDto,
  IntensityUpdateDto,
} from '../proxy/planning/dtos/intensity';
import { INTENSITY_CONFIG, INTENSITY_FIELDS } from './intensity.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-intensity',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, IntensityService, ConfirmationService],
  templateUrl: './intensity.html',
  styleUrl: './intensity.scss',
})
export class Intensity extends BaseCrudComponent<
  IntensityDto,
  IntensityCreateDto,
  IntensityUpdateDto,
  IntensityExcelDownloadDto
> {
  service = inject(IntensityService);
  config = INTENSITY_CONFIG;
  fields = INTENSITY_FIELDS;

  protected prepareUpdateDto(data: any, selected: IntensityDto): IntensityUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Intensity';
  }
}
